module.exports = __webpack_public_path__ + "static/media/covid19-popup-zh-CN-desktop.5ca36624.png";